import {Provider} from "react-redux";
import {persistor, store} from "../store";
import {type ReactNode} from "react";
import {PersistGate} from "redux-persist/integration/react";

interface AppProviderProps {
    children?: ReactNode;
}

const AppProvider = ({children}: AppProviderProps) => {
    return (
        <Provider store={store}>
            <PersistGate loading={null} persistor={persistor}>
                {children}
            </PersistGate>
        </Provider>
    );
};

export default AppProvider;
